// extracted by mini-css-extract-plugin
module.exports = {"card":"JobReportingCard_card__3Vevr","detailsDiv":"JobReportingCard_detailsDiv__3bKLE"};